import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X, ArrowRight } from "@phosphor-icons/react";

const NAV = [
  { to: "/solutions", label: "Solutions" },
  { to: "/demos", label: "Demos" },
  { to: "/how-it-works", label: "How it works" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="glass-header sticky top-0 z-50"
      data-testid="site-header"
    >
      <div className="app-container flex items-center justify-between py-4">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo">
          <img src="/appistry-logo.png" alt="Appistry" className="h-9 w-9 object-contain" />
          <span className="text-lg font-bold tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Appistry
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="nav-desktop">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-zinc-950" : "text-zinc-600 hover:text-zinc-950"
                }`
              }
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/contact" className="btn-signal text-sm" data-testid="header-cta-consultation">
            Get in touch
            <ArrowRight size={16} weight="bold" />
          </Link>
        </div>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-200 bg-white" data-testid="nav-mobile">
          <div className="app-container py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} className="py-2 text-base font-medium text-zinc-800" data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {n.label}
              </Link>
            ))}
            <Link to="/contact" className="btn-signal justify-center mt-2" data-testid="mobile-cta-consultation">
              Get in touch
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
